<template>
    <div ref="container" class="textarea-cell-editor" :style="{width: `${popupWidth}px`}">
        <textarea
            v-model="value"
            ref="textarea"
            :rows="rows"
            :cols="cols"
            :disabled="readonly"
            class="form-control form-control-sm">
        </textarea>
        <div class="font-10 text-right text-muted pt-1">
            <span :class="{ 'text-danger': value && value.length > maxLength }">
                {{ value ? value.length : 0 }}
            </span>
            /
            <span v-tooltip="'Max length'">
                {{ maxLength }}
            </span>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {FieldValidations} from '@/types/document-viewer/field/modules/validation'

export default Vue.extend({
    name: 'AgGridCellEditorTextarea',
    data() {
        return {
            value: null,
            cols: 50,
            rows: 4,
            placeholder: 'Select a value',
            readonly: false
        }
    },
    computed: {
        field() {
            return this.params.column.getColId()
        },

        settings() {
            return this.params.settings || {}
        },

        validations() {
            return this.settings.validations || []
        },

        maxLengthValidation() {
            return this.validations.find(v => v.key === FieldValidations.MAX_LENGTH) || {}
        },

        maxLength() {
            if (this.maxLengthValidation &&
                this.maxLengthValidation.params &&
                _.isNumber(this.maxLengthValidation.params.value)) {
                return this.maxLengthValidation.params.value
            }
            return 1024
        },

        popupWidth() {
            return Math.max(this.params.column.actualWidth, 300)
        }
    },
    methods: {
        getValue() {
            return this.value
        },

        isPopup() {
            return true
        }
    },
    created() {
        this.value = this.params.value
        if (this.params.placeholder) {
            this.placeholder = this.params.placeholder
        }
        if (_.isNumber(this.params.cols)) {
            this.cols = this.params.cols
        }
        if (_.isNumber(this.params.rows)) {
            this.rows = this.params.rows
        }
        if (this.params.readonly) {
            this.readonly = this.params.readonly
        }
    },
    mounted() {
        Vue.nextTick(() => {
            this.$refs.textarea.focus()
        })
    }
})
</script>

<style scoped lang="scss">
    .textarea-cell-editor {
        padding: 8px 8px 4px;
    }
</style>
